
$(function () {
    $(".tab-container li").each(function () {
        var routeToMatch = $(this).data("match-route");
        var altRouteToMatch = $(this).data("match-alt-route");
        var altRoute2ToMatch = $(this).data("match-alt-route2");

        console.log(window.location.href.toLocaleLowerCase());

        if (routeToMatch && window.location.href.toLocaleLowerCase().indexOf(routeToMatch.toLocaleLowerCase()) > -1) {
            $(this).addClass("selected");
        }
        else if (altRouteToMatch && window.location.href.toLocaleLowerCase().indexOf(altRouteToMatch.toLocaleLowerCase()) > -1) {
            $(this).addClass("selected");
        }
        else if (altRoute2ToMatch && window.location.href.toLocaleLowerCase().indexOf(altRoute2ToMatch.toLocaleLowerCase()) > -1) {
            $(this).addClass("selected");
        }
    });
});